// src/Components/partners/PartnerFormModal.jsx
import React, { useState } from 'react';
import { X } from 'lucide-react';

const CATEGORIES = ['partner', 'entrepreneur', 'business', 'media'];

// Used two ways:
// - Blank, from "+ Add Partner Manually" (prefill = null)
// - Pre-filled from an approved application (prefill = { name, country, ... })
// onSubmit receives the form payload; the parent decides whether to call
// createPartner or approveApplication.
export default function PartnerFormModal({ title, prefill, onClose, onSubmit, submitting }) {
  const [form, setForm] = useState({
    name: prefill?.name || '',
    country: prefill?.country || '',
    description: prefill?.description || '',
    logo_url: '',
    offer_title: '',
    offer_url: '',
    category: 'partner',
    is_verified: false,
  });

  const set = (key) => (e) => {
    const val = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setForm((f) => ({ ...f, [key]: val }));
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl p-6 max-w-lg w-full max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold">{title}</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X size={18} />
          </button>
        </div>

        <div className="space-y-3">
          <div>
            <label className="text-xs font-medium text-gray-500">Name</label>
            <input value={form.name} onChange={set('name')}
              className="mt-1 w-full px-3 py-2 border border-gray-200 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700 text-sm" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-xs font-medium text-gray-500">Country</label>
              <input value={form.country} onChange={set('country')}
                className="mt-1 w-full px-3 py-2 border border-gray-200 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700 text-sm" />
            </div>
            <div>
              <label className="text-xs font-medium text-gray-500">Category</label>
              <select value={form.category} onChange={set('category')}
                className="mt-1 w-full px-3 py-2 border border-gray-200 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700 text-sm">
                {CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
          </div>
          <div>
            <label className="text-xs font-medium text-gray-500">Description</label>
            <textarea value={form.description} onChange={set('description')} rows={2}
              className="mt-1 w-full px-3 py-2 border border-gray-200 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700 text-sm" />
          </div>
          <div>
            <label className="text-xs font-medium text-gray-500">Logo URL</label>
            <input value={form.logo_url} onChange={set('logo_url')} placeholder="https://..."
              className="mt-1 w-full px-3 py-2 border border-gray-200 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700 text-sm" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-xs font-medium text-gray-500">Offer Title</label>
              <input value={form.offer_title} onChange={set('offer_title')}
                className="mt-1 w-full px-3 py-2 border border-gray-200 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700 text-sm" />
            </div>
            <div>
              <label className="text-xs font-medium text-gray-500">Offer URL</label>
              <input value={form.offer_url} onChange={set('offer_url')} placeholder="https://..."
                className="mt-1 w-full px-3 py-2 border border-gray-200 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700 text-sm" />
            </div>
          </div>
          <label className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-300">
            <input type="checkbox" checked={form.is_verified} onChange={set('is_verified')} />
            Mark as verified
          </label>
        </div>

        <div className="flex gap-2 justify-end mt-6">
          <button onClick={onClose} disabled={submitting}
            className="px-4 py-2 text-sm text-gray-500 hover:bg-gray-100 rounded-lg transition">
            Cancel
          </button>
          <button onClick={() => onSubmit(form)} disabled={submitting || !form.name}
            className="px-4 py-2 text-sm bg-red-600 text-white rounded-lg hover:bg-red-700 transition disabled:opacity-50">
            {submitting ? 'Saving...' : 'Save Partner'}
          </button>
        </div>
      </div>
    </div>
  );
}